import { Link } from 'react-router-dom';
import config from '../../config';
import { getActiveFiltersCount } from './utils/filters';
import { formatCounter } from '../../utils/formatCounter';

export function FiltersCount() {
  return (
    <Link className="relative" to={config.ROUTES.FILTERS}>
      <img src="/icons/Button-filters.svg" className="w-[119px] h-[44px] flex-shrink-0 cursor-pointer" />
      {getActiveFiltersCount() > 0 && (
        <div className="absolute -top-0.5 -right-0.5 bg-[#A1F69E] text-black rounded-full min-w-[16px] h-[16px] flex items-center justify-center text-[10px] font-bold px-1">
          {formatCounter(getActiveFiltersCount())}
        </div>
      )}
    </Link>
  );
}
